import Axios from 'axios'
import { Dispatch } from 'redux'

import { Order, OrderReview, OrderStatusData, OrderTypes } from './types'
import { ActionResponse, Id } from 'util/types/index'

export function changeOrderReviewStatus (pId: Id, orderId: Id, reviewId: Id, status: OrderReview['status']) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Order>> => {
    return Axios
      .patch(`/order/${orderId}/review/${reviewId}/status`, { status })
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success') {
          getOrder(pId, orderId)(dispatch)
        }
        return res
      })
  }
}

export function changeOrderStatus (pId: Id, orderId: Id, data: OrderStatusData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Order>> => {
    return Axios
      .patch(`/partner/${pId}/order/${orderId}/status`, data)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success') {
          getOrder(pId, orderId)(dispatch)
        }
        return res
      })
  }
}

export function getOrder (partnerId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Order>> => {
    return Axios
      .get(`/partner/${partnerId}/order/${id}`)
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: OrderTypes.ORDER_GET, payload: res.data, partnerId })
        }
        return res
      })
  }
}

export function getOrderList (params?: any) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Order[]>> => {
    return Axios
      .get('/orders/panel', { params })
      .then(res => res.data)
      .then(async res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: OrderTypes.ORDER_LIST, payload: res.data, pagination: res.pagination })
        }
        return res
      })
  }
}
